import React, { useEffect, useState } from 'react'
import FormGroup from 'react-bootstrap/FormGroup'
import { Radio } from './Radio'
import { RadioGroupProps } from './types'

const RadioGroup = (props: RadioGroupProps) => {
    const { name, data, selectedValue, updateState } = props
    const [value, setValue] = useState<number>(selectedValue)

    useEffect(() => {
        setValue(selectedValue)
    }, [selectedValue])

    return (
        <FormGroup className="mb-3">
            {data.map((el, i) => (
                <Radio
                    key={i}
                    value={el.value}
                    checked={value === el.value}
                    name={name}
                    label={el.label}
                    onClick={e => {
                        setValue(Number.parseInt(e.target.value))
                        updateState(name, Number.parseInt(e.target.value))
                    }}
                />
            ))}
        </FormGroup>
    )
}

export default RadioGroup
